import React from 'react';
import { AlertCircle } from 'lucide-react';
import '../App.css'; // Uses error-card styles

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="card duo-error error-card" aria-live="assertive" style={{ margin: '20px auto', maxWidth: '600px' }}>
          <div className="error-emoji" aria-hidden="true">🛠️</div>
          <div className="error-header">
            <AlertCircle size={28} style={{ color: '#ff4b4b' }} aria-hidden="true" />
            <h3 className="error-title">Oops! Our Mascot Tripped</h3>
          </div>
          <p className="error-message">Something went wrong in the application UI.</p>
          <p className="error-subtitle">Please refresh the page and try again! 🦉</p>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
